import { GLOBALS } from 'constants/settings';
import { LOADER } from 'constants/copy';

class Pagination {
  constructor(elems) {
    this.elems = elems;

    $(document).on('click', '.js-pagination-get', (e) => {
      e.preventDefault();
      this.lastTarget = e.target;
      this.paginate(e.target.dataset, this.lastTarget.classList.contains('btn'));
    });

    this.loadGrid();
  }

  paginate(data, btn) {
    if (!data || !data.page) {
      console.warn('Pagination::paginate Error: Requires data.')
      return;
    }

    let query = {
      page     : (data.page !== undefined) ? data.page : null,
      type     : (data.type !== undefined) ? data.type : null,
      exclude  : (data.exclude !== undefined) ? data.exclude : null,
      tags     : (data.tags !== undefined) ? data.tags : null,
      terms    : (data.terms !== undefined) ? data.terms : null,
      creators : (data.creators !== undefined) ? data.creators : null,
      must_type: (data.mtype !== undefined) ? data.mtype : null,
      location : (data.mlocation !== undefined) ? data.mlocation : null,
    };

    let target = this.lastTarget;
    if (btn) {
      $(this.lastTarget).prop('disabled', true).text(LOADER.loading);
    } else {
      if (query.type === 'Musts' && query.location === '' && query.must_type === '') {
        window.location.href = "/musts";
        return;
      }
    }

    $.ajax({
      url: '/articles/paginate',
      dataType: 'script',
      data: query,
    })
    .done(function() {
      if (parseInt(query.page)) window.history.pushState(null, null, '?page=' + (parseInt(query.page) + 1))
      if (btn) $(target).prop('disabled', false).text(LOADER.loadMore);
    });
  }

  loadGrid() {
    $('.article-grid-item.inactive').each((i) => {
      let $that = $('.article-grid-item.inactive').eq(i);
      setTimeout((i) => {
        $that.removeClass('inactive');
      }, Math.max(GLOBALS.transition, (i + 2) / 2 * GLOBALS.transition));
    });
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./app/javascript/global/pagination.js